"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartBoxCountGroupCard = void 0;
const ChartType_1 = __importDefault(require("@opsbase/lib-chart/ChartType"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
const ChartBoxTypePicker_1 = __importDefault(require("../ChartBox/ChartBoxTypePicker"));
const CountGroupChart_1 = __importDefault(require("../CountGroupChart"));
function ChartBoxCountGroupCard(props) {
    var _a;
    const dt = (0, useDataTree_1.default)();
    const { chart } = props;
    const groupDim = QueryFieldRegistry_1.default[chart.config.dimension];
    const { toggleHighlightedGroup } = (0, useViewActions_1.default)(dt.viewId);
    const { highlightedGroups } = (0, useView_1.default)(dt.viewId);
    let highlightXId = (_a = highlightedGroups.find(h => h.queryFieldKey === groupDim.key)) === null || _a === void 0 ? void 0 : _a.id;
    const handleClickValue = (0, react_1.useCallback)(d => {
        toggleHighlightedGroup(dt.groupsById.get(d.x.id));
    }, [dt.groupsById, toggleHighlightedGroup]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Vertical_1.default, { centered: true },
        react_1.default.createElement(Text_1.default, { variant: "small" }, groupDim.label),
        react_1.default.createElement(Pane_1.default, { grow: true }),
        react_1.default.createElement(CountGroupChart_1.default, { chart: chart, width: 160, height: 160, highlightXId: highlightXId, onClickValue: handleClickValue }),
        react_1.default.createElement(Pane_1.default, { grow: true }),
        react_1.default.createElement(ChartBoxTypePicker_1.default, { chart: chart, options: [ChartType_1.default.PIE2D, ChartType_1.default.BAR2D] }))), [chart, groupDim.label, handleClickValue, highlightXId]);
}
exports.ChartBoxCountGroupCard = ChartBoxCountGroupCard;
exports.default = ChartBoxCountGroupCard;
